/** token 存取操作文件 */
let token = null
const getToken = () => {
  return localStorage.getItem('token') || null
}
const setToken = (t) => {
  token = t
  localStorage.setItem('token', token)
}
export {
  getToken,
  setToken
}